// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__CtMKR","file":"styles_file__3KNwq"};